<template>
  <span class="whiteMainTitle text-center">{{ $t('coreListOfWinners') }}</span>

  <div
    class="settingsBarPusher"
    :class="{
      settingsBarPusherMobile: $device.isMobile
    }"
  >
    <el-checkbox
      v-model="pusherUserStatsShowOwnInjected"
      class="isOwnCheckbox"
      :style="{
        '--el-checkbox-checked-bg-color': '#00A906',
        '--el-checkbox-bg-color': '#A49686'
      }"
      >{{ $t('showOwnGames') }}
    </el-checkbox>
  </div>
  <div class="pusher-stats-wrapper">
    <TavernPusherWinnersList />
  </div>
</template>

<script setup lang="ts">
const pusherUserStatsShowOwnInjected = inject<Ref<boolean>>('pusherUserStatsShowOwn');
</script>

<style scoped lang="scss">
.text-center {
  text-align: center;
}
.pusher-stats-wrapper {
  height: 100%;
  margin-top: 14px;
}

.settingsBarPusher {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 20px;
  padding: 0 32px;
  width: 100%;
  height: 18px;
  margin-top: 12px;
}

.settingsBarPusherMobile {
  padding: 0;
}
</style>

<style lang="scss">
.isOwnCheckbox {
  justify-content: flex-end;
  max-width: 100%;
  align-items: center;

  .el-checkbox__label {
    color: #fff;
    font-size: 18px;
    font-family: Eczar;
    line-height: 1;
    font-weight: 500;
  }

  .el-checkbox__inner {
    border-color: #fff;
  }

  .el-checkbox__input {
    height: 14px;
    margin-top: 0;
  }
}
</style>
